<template>
    <div>
        <van-nav-bar title="诗颂" left-arrow @click-left="$router.push('/poem')" />

        <div id="mse"></div>

        <van-cell title="" v-if="loading">
            <template #label>
                <van-skeleton title :row="5" style="padding: 0px" />
            </template>
        </van-cell>

        <template v-else>
            <div class="vedio-title">{{ poem.track_sn }}. {{ poem.title }}</div>
            <div class="list">曲目列表</div>
            <van-list
                :offset="50"
                v-model="listLoading"
                :finished="listFinished"
                finished-text="没有更多了"
                @load="onLoad"
                :error.sync="error"
                error-text="加载,点击重新加载"
            >
                <van-row style="padding: 5px 0">
                    <van-col span="24" v-for="item in poems.data" :key="item.id">
                        <div class="poem-list-item">
                            <my-image :src="item.poster" />
                            <span :class="{ blue: poem.track_sn === item.track_sn }" @click="handlePoemPlay(item)">
                                {{ item.track_sn + '. ' + item.title }}
                                <span v-if="poem.track_sn === item.track_sn">- 正在播放</span>
                            </span>
                        </div>
                    </van-col>
                </van-row>
            </van-list>
        </template>
    </div>
</template>

<script>
import MyImage from '@/components/MyImage'
import XGPlayer from 'xgplayer'
import { getPoems, getPoemDetail } from '@/api/bible'

const scrollToTop = () => {
    let sTop = document.documentElement.scrollTop || document.body.scrollTop
    if (sTop > 0) {
        window.requestAnimationFrame(scrollToTop)
        window.scrollTo(0, sTop - sTop / 8)
    }
}

export default {
    name: 'PoemVideo',
    components: { MyImage },
    data() {
        return {
            loading: true,
            player: null,
            listLoading: false,
            listFinished: false,
            error: false,
            poems: {
                meta: {
                    current_page: 0,
                    last_page: 0,
                },
                data: [],
            },
            poem: {
                url: '',
                title: '',
                track_sn: '',
                video_uul: '',
            },
            playerOptions: {
                id: 'mse',
                url: '',
                fluid: true,
                videoInit: true,
                poster: '',
                ignores: ['volume'],
                playsinline: true,
                playbackRate: [0.5, 0.75, 1, 1.5, 2],
                noLog: true,
                preload: 'meta',
                preloadTime: 5,
                closeVideoClick: false,
                closeVideoTouch: false,
                definitionActive: 'click',
                autoplay: true,
                playNext: {
                    urlList: [],
                },
            },
        }
    },
    created() {
        getPoemDetail(this.$route.query.id).then((res) => {
            this.poem = res.data
            this.loading = false
        })
    },
    watch: {
        poem(newVal) {
            if (this.player !== null) {
                this.player.src = newVal.video_url
            } else {
                this.playerOptions.url = newVal.video_url
                this.player = new XGPlayer(this.playerOptions)
            }
        },
    },
    methods: {
        handlePoemPlay(poem) {
            if (this.poem.id === poem.id) {
                return
            }
            this.poem = poem
            // 动态修改路由传参的值
            this.$router.push({
                query: { ...this.$route.query, id: this.poem.id },
            })

            scrollToTop()
        },
        loadSuccess() {
            // 处理下一集播放
            this.poems.data.forEach((item) => {
                this.playerOptions.playNext.urlList.push(item.video_url)
            })
            this.$nextTick(() => {
                // 播放结束后自动进入下一首
                this.player.on('ended', () => {
                    const end = this.poems.data[this.poems.data.length - 1]

                    if (end.id === this.poem.id) {
                        this.poem = this.poems.data[0]
                        return
                    }
                    for (let i = 0; i < this.poems.data.length; i++) {
                        const item = this.poems.data[i]
                        if (this.poem.id === item.id) {
                            this.poem = this.poems.data[i + 1]
                            break
                        }
                    }
                    this.$router.push({
                        query: { ...this.$route.query, id: this.poem.id },
                    })
                })
            })
        },
        onLoad() {
            getPoems({
                pageSize: 500,
                page: this.poems.meta.current_page + 1,
                keyword: this.keyword,
            })
                .then((res) => {
                    res.data.unshift(...this.poems.data)
                    this.poems = res
                    // console.log('this.poems' + JSON.stringify(this.poems))
                    this.listLoading = false
                    // 数据全部加载完成
                    if (res.meta.current_page === res.meta.last_page) {
                        this.listFinished = true
                    }
                    this.loadSuccess()
                })
                .catch(() => {
                    this.error = true
                })
        },
    },
}
</script>

<style lang="less" scoped>
.vedio-title {
    background: white;
    padding: 20px 15px;
}

.list {
    color: @grey;
    padding: 20px 15px 10px;
    font-size: @medium-font-size;
    background: @bg;
}

.van-list {
    height: calc(100vh - 380px);
    overflow-y: scroll;
}

.poem-list-item {
    background: #fff;
    border-radius: 4px;
    font-size: @medium-font-size;
    padding: 10px 15px;
    display: flex;
    align-items: center;

    /deep/ .van-image__img,
    .full-width {
        width: 80px;
        aspect-ratio: 7/4;
        margin-right: 10px;
        border-radius: @medium-border-radius;
    }

    span {
        flex: 1;
    }
}

.blue {
    color: @blue;
}
</style>
